import * as Icons from 'icons/index'

export const IconSizes = {
  // TODO need change icon sizes gradation
  sSmall: '0.875rem',
  small: '1rem',
  sm: '1.125rem',
  mSm: '1.25rem',
  xMSm: '1.375rem',
  xSm: '1.5rem',
  medium: '1.5em',
  xMedium: '1.625rem',
  xxMedium: '2rem',
  large: '2em',
  smLarge: '2.25rem',
  mLarge: '2.5rem',
  xLarge: '3rem',
  xxLarge: '3.5em',
  xxmLarge: '4rem',
  xxxLarge: '4.5rem',
  bigger: '5.5rem',
  sBig: '5.75rem',
  smBig: '6rem',
  big: '6.5rem',
  mBig: '8.5rem',
  xmBig: '9.75rem',
  xBigger: '12.5rem',
  xxBigger: '23.5rem',
} as const
export type IconSizes = (typeof IconSizes)[keyof typeof IconSizes]

export const IconSocialSizes = {
  appStore: '86px',
  googlePlay: '96px',
} as const
export type IconSocialSizes =
  (typeof IconSocialSizes)[keyof typeof IconSocialSizes]

export const IconQualitySizes = {
  dolbyAtmos: '59px',
  qualityBadge2k: '38px',
  qualityBadge4k: '38px',
  qualityBadgeFhd: '44px',
  qualityBadgeHd: '38px',
  qualityBadgeSd: '38px',
} as const
export type IconQualitySizes =
  (typeof IconQualitySizes)[keyof typeof IconQualitySizes]

export const IconNames = {
  activity: 'activity',
  activitySolid: 'activitySolid',
  angleLeft: 'angleLeft',
  angleRight: 'angleRight',
  angleDown: 'angleDown',
  angleUp: 'angleUp',
  arrowLeft: 'arrowLeft',
  arrowUp: 'arrowUp',
  arrowDown: 'arrowDown',
  arrowRight: 'arrowRight',
  backward: 'backward',
  backwardSolid: 'backwardSolid',
  burger: 'burger',
  chat: 'chat',
  chatSolid: 'chatSolid',
  check: 'check',
  close: 'close',
  document: 'document',
  dots: 'dots',
  discovery: 'discovery',
  discoverySolid: 'discoverySolid',
  eyeOpen: 'eyeOpen',
  eyeCrossed: 'eyeCrossed',
  floatingVideo: 'floatingVideo',
  forward: 'forward',
  forwardSolid: 'forwardSolid',
  heart: 'heart',
  heartSolid: 'heartSolid',
  favoriteToggle: 'favoriteToggle',
  plusFavoriteIcon: 'plusFavoriteIcon',
  selectedFavoriteIcon: 'selectedFavoriteIcon',
  quality: 'quality',
  qualityBadge2k: 'qualityBadge2k',
  qualityBadge4k: 'qualityBadge4k',
  qualityBadgeFhd: 'qualityBadgeFhd',
  qualityBadgeHd: 'qualityBadgeHd',
  qualityBadgeSd: 'qualityBadgeSd',
  home: 'home',
  homeSolid: 'homeSolid',
  info: 'info',
  bookmark: 'bookmark',
  maximize: 'maximize',
  minimize: 'minimize',
  mute: 'mute',
  noContent: 'noContent',
  notify: 'notify',
  pause: 'pause',
  pauseSolid: 'pauseSolid',
  play: 'play',
  playSolid: 'playSolid',
  picInPic: 'picInPic',
  save: 'save',
  send: 'send',
  soundOn: 'soundOn',
  soundOff: 'soundOff',
  search: 'search',
  settings: 'settings',
  settingsSolid: 'settingsSolid',
  table: 'table',
  tv: 'tv',
  tvSolid: 'tvSolid',
  unnotify: 'unnotify',
  avatarWoman: 'avatarWoman',
  setplex: 'setplex',
  lines: 'lines',
  chromecast: 'chromecast',
  audio: 'audio',
  subtitles: 'subtitles',
  visaCard: 'visaCard',
  masterCard: 'masterCard',
  aeCard: 'aeCard',
  restart: 'restart',
  user: 'user',
  facebookSolid: 'facebookSolid',
  facebookCenteredSolid: 'facebookCenteredSolid',
  appleSolid: 'appleSolid',
  googleSolid: 'googleSolid',
  ghost: 'ghost',
  ghost404: 'ghost404',
  ghost500: 'ghost500',
  ghost502: 'ghost502',
  googlePlay: 'googlePlay',
  appStore: 'appStore',
  amazonStore: 'amazonStore',
  rewindLeft: 'rewindLeft',
  rewindRight: 'rewindRight',
  twitterSolid: 'twitterSolid',
  instagram: 'instagram',
  logOut: 'logOut',
  playlist: 'playlist',
  pinLock: 'pinLock',
  redirect: 'redirect',
  accountSettings: 'accountSettings',
  plus: 'plus',
  edit: 'edit',
  remove: 'remove',
  trueIdLogo: 'trueIdLogo',
  none: '',
  crown: 'crown',
  tvPinLock: 'tvPinLock',
  geoblock: 'geoblock',
  verticalVideo: 'verticalVideo',
  dolbyAtmos: 'dolbyAtmos',
  dolbyAtmosInline: 'dolbyAtmosInline',
  microphone: 'microphone',
  editNote: 'editNote',
  editPencil: 'editPencil',
  kidsProfile: 'kidsProfile',
  searchHint: 'searchHint',
  externalContent: 'externalContent',
} as const
export type IconNames = (typeof IconNames)[keyof typeof IconNames]

export const IconsMap = {
  activity: Icons.ActivityIcon,
  activitySolid: Icons.ActivitySolidIcon,
  angleLeft: Icons.AngleLeftIcon,
  angleRight: Icons.AngleRightIcon,
  angleDown: Icons.AngleDownIcon,
  angleUp: Icons.AngleUpIcon,
  arrowLeft: Icons.ArrowLeftIcon,
  arrowUp: Icons.ArrowUpIcon,
  arrowDown: Icons.ArrowDownIcon,
  arrowRight: Icons.ArrowRightIcon,
  backward: Icons.BackwardIcon,
  backwardSolid: Icons.BackwardSolidIcon,
  burger: Icons.BurgerIcon,
  chat: Icons.ChatIcon,
  chatSolid: Icons.ChatSolidIcon,
  check: Icons.CheckIcon,
  close: Icons.CloseIcon,
  document: Icons.DocumentIcon,
  dots: Icons.DotsIcon,
  editNote: Icons.EditNoteIcon,
  editPencil: Icons.EditPencilIcon,
  discovery: Icons.DiscoveryIcon,
  discoverySolid: Icons.DiscoverySolidIcon,
  eyeOpen: Icons.EyeOpenIcon,
  eyeCrossed: Icons.EyeCrossedIcon,
  floatingVideo: Icons.FloatingVideoIcon,
  forward: Icons.ForwardIcon,
  forwardSolid: Icons.ForwardSolidIcon,
  heart: Icons.HeartIcon,
  heartSolid: Icons.HeartSolidIcon,
  favoriteToggle: Icons.FavoriteToggleIcon,
  plusFavoriteIcon: Icons.PlusFavoriteIcon,
  selectedFavoriteIcon: Icons.SelectedFavoriteIcon,
  home: Icons.HomeIcon,
  homeSolid: Icons.HomeSolidIcon,
  info: Icons.InfoIcon,
  bookmark: Icons.BookmarkIcon,
  maximize: Icons.MaximizeIcon,
  minimize: Icons.MinimizeIcon,
  mute: Icons.MuteIcon,
  noContent: Icons.NoContent,
  notify: Icons.NotifyIcon,
  pause: Icons.PauseIcon,
  pauseSolid: Icons.PauseSolidIcon,
  play: Icons.PlayIcon,
  playSolid: Icons.PlaySolidIcon,
  picInPic: Icons.PicInPicIcon,
  save: Icons.SaveIcon,
  search: Icons.SeacrhIcon,
  send: Icons.SendIcon,
  settings: Icons.SettingsIcon,
  settingsSolid: Icons.SettingsSolidIcon,
  soundOn: Icons.SoundOnIcon,
  soundOff: Icons.SoundOffIcon,
  table: Icons.TableIcon,
  tv: Icons.TvIcon,
  tvSolid: Icons.TvSolidIcon,
  unnotify: Icons.UnNotifyIcon,
  avatarWoman: Icons.WomanAvatar,
  setplex: Icons.SetplexIcon,
  lines: Icons.LinesIcon,
  chromecast: Icons.ChromecastIcon,
  audio: Icons.AudioIcon,
  subtitles: Icons.SubtitlesIcon,
  visaCard: Icons.VisaCardIcon,
  masterCard: Icons.MasterCardIcon,
  aeCard: Icons.AECardIcon,
  restart: Icons.RestartIcon,
  user: Icons.UserIcon,
  facebookSolid: Icons.FacebookSolidIcon,
  facebookCenteredSolid: Icons.FacebookCenteredSolidIcon,
  appleSolid: Icons.AppleSolidIcon,
  googleSolid: Icons.GoogleSolidIcon,
  ghost: Icons.GhostIcon,
  ghost404: Icons.Ghost404Icon,
  ghost500: Icons.Ghost500Icon,
  ghost502: Icons.Ghost502Icon,
  googlePlay: Icons.GooglePlayIcon,
  appStore: Icons.AppStoreIcon,
  amazonStore: Icons.AmazonStoreIcon,
  rewindLeft: Icons.RewindLeftIcon,
  rewindRight: Icons.RewindRightIcon,
  twitterSolid: Icons.TwitterSolidIcon,
  tvPinLock: Icons.TvPinLockIcon,
  instagram: Icons.InstagramIcon,
  logOut: Icons.LogOutIcon,
  playlist: Icons.PlaylistIcon,
  pinLock: Icons.PinLockIcon,
  redirect: Icons.RedirectIcon,
  accountSettings: Icons.AccountSettingsIcon,
  plus: Icons.PlusIcon,
  edit: Icons.EditIcon,
  remove: Icons.RemoveIcon,
  trueIdLogo: Icons.TrueIdLogoIcon,
  crown: Icons.CrownIcon,
  quality: Icons.QualityIcon,
  qualityBadge2k: Icons.QualityBadge2kIcon,
  qualityBadge4k: Icons.QualityBadge4kIcon,
  qualityBadgeFhd: Icons.QualityBadgeFhdIcon,
  qualityBadgeHd: Icons.QualityBadgeHdIcon,
  qualityBadgeSd: Icons.QualityBadgeSdIcon,
  geoblock: Icons.GeoblockIcon,
  verticalVideo: Icons.VerticalVideoIcon,
  dolbyAtmos: Icons.DolbyAtmosIcon,
  dolbyAtmosInline: Icons.DolbyAtmosInlineIcon,
  microphone: Icons.MicrophoneIcon,
  kidsProfile: Icons.KidsProfileSolidIcon,
  searchHint: Icons.SearchHintIcon,
  externalContent: Icons.ExternalContentIcon,
}
